import HttpUtils from "../../../utils/http.utils";
import { IGetFile } from "../../common/interfaces/common.interface";

export default class TermsAndConditionsAPI {
  public static getTermsAndConditionsPdf(): Promise<IGetFile | void> {
    return HttpUtils.getFile("/terms-and-conditions");
  }
}
